import { GiftCard } from '../data-models';
import { EventTicket } from '../models/serializable/event-ticket';
import { Fee } from '../models/serializable/fee';
import { Price } from '../models/serializable/price';
import { ProductOrderItem } from '../models/serializable/product-order-item';

export abstract class FeeHelper {
  static calculateFeeValueForEventTicket(ticket: EventTicket): { price: Price, fee: Fee } | null {
    const applicationFee = ticket.applicationFee;
    if(applicationFee == null) {
      return null;
    }

    let ticketPrice = ticket.template.price;
    if(ticket.supplement != null) {
      ticketPrice = ticketPrice.add(ticket.supplement.template.price);
    }

    const unitFeePrice = applicationFee.calculateUnitFee(ticketPrice);
    if(!unitFeePrice.isPositive()) {
      return null;
    }

    return { price: unitFeePrice, fee: applicationFee };
  }

  static calculateFeeValueForProductOrderItem(orderItem: ProductOrderItem, options?: { applyScaling?: boolean }): { price: Price, fee: Fee } | null {
    const applicationFee = orderItem.applicationFee;
    if(applicationFee == null) {
      return null;
    }

    const productPrice = orderItem.product.price;

    const unitFeePrice = applicationFee.calculateUnitFee(productPrice);
    if(!unitFeePrice.isPositive()) {
      return null;
    }

    const applyScaling = options?.applyScaling ?? true;
    const feePrice = applyScaling ?
      unitFeePrice.scale(orderItem.quantity):
      unitFeePrice;

    return { price: feePrice, fee: applicationFee };
  }

  static calculateFeeValueForGiftCard(giftCard: GiftCard): { price: Price, fee: Fee } | null {
    const applicationFee = giftCard.applicationFee;
    if(applicationFee == null) {
      return null;
    }

    const unitFeePrice = applicationFee.calculateUnitFee(giftCard.price);
    if(!unitFeePrice.isPositive()) {
      return null;
    }

    return { price: unitFeePrice, fee: applicationFee };
  }
}
